// 这段可选代码用于注册一个 service worker。
// register() 不会默认被调用。

// 这允许你的应用加载更快，在后续访问中提供离线功能，
// 但也意味着开发人员（也就是你）需要更多地注意某些问题：
// https://cra.link/PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] 是 IPv6 的 localhost 地址。
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 被认为是 localhost，用于 IPv4。
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // URL 构造函数是浏览器支持 SW 的一个好标志。
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // 如果我们的源不同于 PUBLIC_URL 的源，则不会工作 service worker，
      // 因为它会被提供服务的不同源。
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // 这是在本地运行的：让我们检查一下 service worker 是否仍然存在。
        checkValidServiceWorker(swUrl, config);

        // 添加一些额外的日志到本地主机控制台，特别是对开发人员有用
        // 如果 service worker/PWA 文档很感兴趣。
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'This web app is being served cache-first by a service ' +
              'worker. To learn more, visit https://cra.link/PWA'
          );
        });
      } else {
        // 不是本地主机。只需注册 service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // 此时，更新的预缓存内容已被获取，
              // 但以前的 service worker 仍将提供
              // 旧内容的服务，直到所有客户端标签都关闭。
              console.log(
                'New content is available and will be used when all ' +
                  'tabs for this page are closed. See https://cra.link/PWA.'
              );

              // 执行回调
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // 此时，一切都已预缓存。
              // 这是说"内容被缓存以供离线使用"的完美时机。
              console.log('Content is cached for offline use.');

              // 执行回调
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // 检查是否可以找到 service worker。如果不能，重新加载页面。
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // 确保 service worker 存在，以及我们确实得到了一个 JS 文件。
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // 没有找到 service worker。可能是在不同的应用。重新加载页面。
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker 找到了。正常继续。
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}